// extracted by mini-css-extract-plugin
export default {"panel":"panel___MS0DI","body":"body___KAWzi","title":"title___LmknG","subtitle":"subtitle___htVK1"};